export interface ImageState {
  fighterImages: Record<string, string>;
  loadingImages: Record<string, boolean>;
  isLoading: boolean;
  error: string | null;
}

export const initialImageState: ImageState = {
  fighterImages: {},
  loadingImages: {},
  isLoading: false,
  error: null,
};
